module.exports = __webpack_public_path__ + "img/diploma.d4f11f67.png";